// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2ORPk","form":"styles_form__2tJh7"};